<template>
  <div class="content">
    <div class="comp-bread-crumb">
      <span>当前位置：</span>
      <el-breadcrumb class="app-breadcrumb" separator="/">
        <el-breadcrumb-item v-for="(item,index) in levelList" :key="item.title">
          <template v-if="item.title">
            <span v-if="index === levelList.length-1" class="no-redirect">{{item.title}}</span>
            <router-link v-else :to="{name: item.name}">{{item.title}}</router-link>
          </template>
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'BreadCrumb',
    created () {
      this.getBreadcrumb()
    },
    data () {
      return {
        levelList: null
      }
    },
    watch: {
      $route () {
        this.getBreadcrumb()
      }
    },
    methods: {
      getBreadcrumb () {
        // 主页到当前页面中的页面路由信息
        let _meta = this.$route.meta
        // 当前页面路由信息
        let currentRoute = {title: _meta.title}
        // 主页面 + 主页面到当前页面中的页面 + 当前页面
        this.levelList = [{name: 'Index', title: '首页'}].concat(_meta.prevRouter || [], currentRoute)
        // console.log(this.levelList)
      }
    }
  }
</script>

<style lang="less">
  .comp-bread-crumb{
    padding:16px 0;
    /*font-size: 14px;*/
    color:#999;
    display: flex;
    .app-breadcrumb{
      display: inline-block;
    }
    .el-breadcrumb {
      line-height: inherit;
      display: inline-block;
      .no-redirect {
        cursor: text;
      }
      a{
        color:#999;
      }
    }
  }
</style>
